module.exports = __webpack_public_path__ + "img/HP_00_mono_AE_00002.f55fbda9.png";